module.exports = __webpack_public_path__ + "img/mochi.75351d48.png";